import { render, staticRenderFns } from "./studentBillDetail.vue?vue&type=template&id=a8cea65a&scoped=true"
import script from "./studentBillDetail.vue?vue&type=script&lang=js"
export * from "./studentBillDetail.vue?vue&type=script&lang=js"
import style0 from "./studentBillDetail.vue?vue&type=style&index=0&id=a8cea65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cea65a",
  null
  
)

export default component.exports